<template>
    <a-modal 
        v-model="visible" 
        :title="$t('modal.approve')" 
        :closable="false" 
        :ok-text="$t('modal-btn.alter-confirm-btn-caption')" 
        :cancel-text="$t('modal-btn.alter-cancel-btn-caption')" 
        @ok="handleOk" 
        @cancel="handleCancel"
    >
        <h4>{{text}}</h4>
    </a-modal>
</template>

<script>
import { companyEnlistmentClient } from "../../../../api/config.js";
import { toastMixin } from "../../../../mixins/ToastMixin.js";
export default {
    name: "CompanyApproveModal",
    mixins: [ toastMixin ],
    data(){
        return{
            visible: false,
            applicantId: "",
            status: ''
        }
    },
    computed: {
        title() {
            if (this.status == 'PENDING') {
                return this.$t('modal.pending1');
            } else if (this.status == 'PENDING1') {
                return this.$t('modal.pending2');
            } else if (this.status == 'PENDING2'){
                return this.$t('modal.approve');
            }
            return '';
        },
        text () {
            if (this.status == 'PENDING') {
                return this.$t('approve-modal.title-pending1');
            } else if (this.status == 'PENDING1') {
                return this.$t('approve-modal.title-pending2');
            } else if (this.status == 'PENDING2'){
                return this.$t('approve-modal.title-application');
            }
            return '';
        }
    },
    methods:{
        showModal(id, status) {
            this.visible = true;
            this.applicantId = id;
            this.status = status;
        },
        handleCancel(){
            this.visible = false;
        },
        handleOk(){
            let data = {
                "id": this.applicantId,
            }
            if (this.status == 'PENDING') {
                companyEnlistmentClient.pending1(data).then(res => {
                    if (!res.networkError){
                        if (res.status == 202){
                            this.successToast(this.$t('toast-success-messages.pending1-application'));
                            this.visible = false;
                            this.$emit('status-changed', { id: this.applicantId, status: 'PENDING1'});
                        }else{
                            this.errorToast(this.$t('toast-error-message.error') + res.status);
                        }
                    }else{
                        this.errorToast(this.$t('toast-error-message.network-error'));
                    }
                });
            } else if (this.status == 'PENDING1') {

                companyEnlistmentClient.pending2(data).then(res => {
                    if (!res.networkError){
                        if (res.status == 202){
                            this.successToast(this.$t('toast-success-messages.pending2-application'));
                            this.visible = false;
                            this.$emit('status-changed', { id: this.applicantId, status: 'PENDING2'});
                        }else{
                            this.errorToast(this.$t('toast-error-message.error') + res.status);
                        }
                    }else{
                        this.errorToast(this.$t('toast-error-message.network-error'));
                    }
                });
            } else if (this.status == 'PENDING2') {
                companyEnlistmentClient.approve(data).then(res => {
                    if (!res.networkError){
                        if (res.status == 202){
                            this.successToast(this.$t('toast-success-messages.approve-application'));
                            this.visible = false;
                            this.$emit('status-changed', { id: this.applicantId, status: 'APPROVED'});
                        }else{
                            this.errorToast(this.$t('toast-error-message.error') + res.status);
                        }
                    }else{
                        this.errorToast(this.$t('toast-error-message.network-error'));
                    }
                });
            }
            
        }
    }
}
</script>

<style>

</style>